
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/serwis-aut-dostawczych",
      function () {
        return require("private-next-pages/serwis-aut-dostawczych/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/serwis-aut-dostawczych"])
      });
    }
  